import { toastController } from '@ionic/vue';

const utils = {};

/**
 * Opening of a new tab with the journey to be made for the person
 */
utils.navigateTo = function navigateTo(latitude, longitude) {
  const apiUrl = process.env.VUE_APP_API_URL;
  const navUrl = apiUrl.replace('/pwa-api', '/go/p');

  window.open(`${navUrl}/${latitude},${longitude}`, '_blank');
};

utils.generateArray = function generateArray(size, increment = 1, start = 0) {
  const output = [];

  for (let i = start; i <= size + start; i++) {
    output.push(`${i * increment}`);
  }

  return output;
};

utils.generateDateList = function () {
  const months = [];

  utils.generateArray(6, 1, 0).forEach(index => {
    // get first day of wanted month
    // avoid missing months (e.g february 2025 if we are checking list the 31 of march)
    const date = new Date(
      new Date().getFullYear(),
      new Date().getMonth() - index,
      1,
    );

    // format date to display (ex: 'Janvier 2024')
    const displayed = date.toLocaleDateString('default', {
      month: 'long',
      year: 'numeric',
    });

    // need to add one to month because it's not yet incremented
    // padStart allow to not have '1' but '01'
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const key = `${date.getFullYear()}-${month}`;

    // Capitalize displayed
    months[key] = displayed.charAt(0).toUpperCase() + displayed.slice(1);
  });

  // Convert object to array
  return Object.entries(months);
};

utils.onError = async err => {
  let messageError =
    "Problème lors de l'envoi des données, veuillez réessayer.";

  if (err && err.name === 'NetworkError') {
    messageError = 'Aucune connexion internet';
  } else if (err && err.response && err.response.data) {
    if (err.response.data.message) {
      messageError = err.response.data.message;
    }

    // in case of validation errors for example
    if (err.response.data.errors) {
      messageError = [];

      // add all errors message to our toast
      Object.values(err.response.data.errors).forEach(element => {
        messageError.push(element);
      });

      messageError = messageError.join('<br />');
    }
  }

  const toast = await toastController.create({
    message: messageError,
    duration: 15000,
    color: 'danger',
    position: 'top',
    cssClass: 'toast-rental-coupon',
    buttons: [
      {
        text: 'Fermer',
        role: 'cancel',
      },
    ],
  });
  await toast.present();
};

utils.loadIntercom = () => {
  /**
   * Minified code provided by Intercom
   * But Eslint "beautifies" it
   * + Modified to use directly intercomSettings.app_id
   */
  (function () {
    var w = window;
    var ic = w.Intercom;
    if (typeof ic === 'function') {
      ic('reattach_activator');
      ic('update', w.intercomSettings);
    } else {
      var d = document;
      var i = function () {
        i.c(arguments);
      };
      i.q = [];
      i.c = function (args) {
        i.q.push(args);
      };
      w.Intercom = i;
      var l = function () {
        var s = d.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src =
          'https://widget.intercom.io/widget/' +
          process.env.VUE_APP_INTERCOM_APP_ID;
        var x = d.getElementsByTagName('script')[0];
        x.parentNode.insertBefore(s, x);
      };
      if (document.readyState === 'complete') {
        l();
      } else if (w.attachEvent) {
        w.attachEvent('onload', l);
      } else {
        w.addEventListener('load', l, false);
      }
    }
  })();
};

utils.routeForbidden = async (router, route, baseUrl = 'chantier') => {
  let url = '/listeBonLocation';
  const id = route.params.id;
  const idRide = route.params.idRide;
  const idItem = route.params.idItem;

  if (id && idRide && (baseUrl === 'chantier' || idItem)) {
    url = `/${baseUrl}/${id}/${idRide}`;

    if (idItem) {
      url += `/${idItem}`;
    }
  }

  const toast = await toastController.create({
    message: "Vous n'avez pas le droit d'accéder à cette page",
    duration: 3000,
    color: 'danger',
    position: 'top',
    cssClass: 'toast-rental-coupon',
  });
  await toast.present();

  router.replace(url);
};

/**
 * Used in both hour prestations and daily time reports
 */
const MAX_HOUR = 23;
const POSSIBLE_MINUTES = ['00', '15', '30', '45'];
utils.generatePickerColumns = (
  selectedHours,
  selectedMinutes,
  possibleMinutes = null,
  prefix = '',
) => {
  const hours = [];
  for (let i = 0; i <= MAX_HOUR; i++) {
    let value = i < 10 ? '0' : '';
    hours.push({ text: value + i, value: value + i });
  }

  const minutesArray = possibleMinutes || POSSIBLE_MINUTES;
  const minutes = minutesArray.map(minute => {
    return { text: minute, value: minute };
  });

  return [
    {
      name: `${prefix}hours`,
      options: hours,
      cssClass: 'picker-opts-right hydrated',
      optionsWidth: '34px',
      selectedIndex: selectedHours,
    },
    {
      name: `${prefix}minutes`,
      options: minutes,
      cssClass: 'picker-opts-left hydrated',
      optionsWidth: '34px',
      selectedIndex: minutesArray.indexOf(selectedMinutes),
    },
  ];
};

utils.getAttachmentIconPath = extension => {
  let base = '/assets/icon/';

  if (extension.toLowerCase() === 'pdf') return base + 'pdf.svg';
  if (extension.toLowerCase() === 'png') return base + 'png.svg';
  if (['jpg', 'jpeg', 'bmp', 'webp'].includes(extension.toLowerCase()))
    return base + 'jpg.svg';
  if (['mp4', 'mkv', 'avi', 'mov', '3gp'].includes(extension.toLowerCase()))
    return base + 'mp4.svg';

  return base + 'doc.svg';
};

/**
 * Very similar to Laravel `checkFilesSize`
 */
utils.checkFilesSize = waitingFiles => {
  const uploadMaxFileSize = window.localStorage.getItem('uploadMaxFileSize');
  const postMaxSize = window.localStorage.getItem('postMaxSize');

  const files = Object.values(waitingFiles).flat();

  let fileTooBig = false;
  files.some(f => {
    if (f.size > uploadMaxFileSize) {
      fileTooBig = f;
      return true;
    }

    return false;
  });

  if (fileTooBig) {
    const size = parseFloat(fileTooBig.size / 1024 / 1024).toFixed(1);

    return {
      isOk: false,
      message: `Le fichier ${
        fileTooBig.newName || fileTooBig.name
      } est trop lourd (${size} Mo / ${
        uploadMaxFileSize / 1024 / 1024
      } Mo max), merci de le supprimer.`,
    };
  }

  let totalSize = 0;
  files.forEach(f => {
    totalSize += parseInt(f.size, 10);
  });

  if (totalSize > postMaxSize) {
    const size = parseFloat(totalSize / 1024 / 1024).toFixed(1);

    return {
      isOk: false,
      message: `Le total des fichiers (${size} Mo) est trop lourd (${
        postMaxSize / 1024 / 1024
      } Mo max), merci de séparer en plusieurs envois.`,
    };
  }

  return {
    isOk: true,
  };
};

utils.sendFilesErrorMessage = async message => {
  const errorToast = await toastController.create({
    header: 'Erreur',
    message: message,
    duration: 5000,
    color: 'danger',
    position: 'top',
    cssClass: 'toast-rental-coupon',
  });

  await errorToast.present();
};

utils.getOutsourcingUrlPrefix = typeMission => {
  const prefixes = {
    reservation: 'r',
    livraison: 'l',
    transfert: 't',
  };

  if (prefixes[typeMission]) {
    return prefixes[typeMission];
  }

  return '';
};

export default utils;
